import { isUsdcNativeAsset } from './withdrawalNativeAsset.ts'

type NativeAssetUser = {
  native_asset_id?: string
}

type NativeAsset = {
  id: string
  symbol?: string
}

export { isUsdcNativeAsset }

export function isWeb3WithdrawalAvailable(
  user: NativeAssetUser | undefined,
  assets: Array<NativeAsset>,
): boolean {
  return isUsdcNativeAsset(user?.native_asset_id, assets)
}
